import React, { FC, ReactElement } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames/bind';
import { Statistics } from 'sections/Home/components/Statistics';
import styles from 'sections/Home/components/SectionHeader/SectionHeader.module.scss';

import ImagePlanet from '../../../../../public/images/pages/Home/planet.webp';

const cn = classNames.bind(styles);

type SectionHeaderProps = {
  membersQuantity: number | string;
};

const SectionHeader: FC<SectionHeaderProps> = ({ membersQuantity }): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__info-box')}>
          <h1 className={cn('header__heading')}>NVOCCS & FREIGHT FORWARDING NETWORK</h1>
          <p className={cn('header__heading-description')}>
            Connecting global freight forwarders and NVOCCs. Our advanced ERP system enhances operational efficiency
            and drives growth. Join our freight network to expand your reach, optimize logistics, and stay competitive
            in the dynamic freight forwarding service industry.
          </p>
          <div className={cn('header__buttons')}>
            {/* New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <Link className={cn('header__button-register')} href="/membership">
              Register
            </Link> */}
            <Link className={cn('header__button-more')} href="/company/contact-us">
              Show more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </div>
          <div className={cn('header__statistics-box')}>
            <Statistics membersQuantity={membersQuantity} />
          </div>
        </div>

        <div className={cn('header__planet-box')}>
          <Image
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
            }}
            className={cn('header__planet')}
            src={ImagePlanet}
            alt="planet"
            priority={true}
          />
        </div>
      </div>

      {/* MEMBERS MEETING BANNER */}
      {/* <div className={cn('banner')}>
        <div className={cn('banner__content')}>
          <div className={cn('banner__icon-box')}>
            <img
              className={cn('banner__icon')}
              src='/images/pages/Home/icon-meeting.svg'
              alt='Banner Icon'
            />
          </div>
          <p className={cn('banner__title')}>
            Join us on February 19th at 1:00 PM GST for our Monthly Members Meeting on Zoom.
          </p>

          <p className={cn('banner__subtitle')}>
            We are pleased to introduce our special guest speaker,{' '}
            <span className={cn('banner__text-bold')}>Mr. Dipen Chheda, CEO of Sukhin Global Logistics</span>, our DFA Premium Member in India.<br />{' '}
            Dipen will present his company’s services and areas of expertise.
          </p>
          <button className={cn('banner__register')}>
            <Link
              target="_blank"
              href="https://assets-eur.mkt.dynamics.com/97490e54-fad8-444f-95d3-13ab26ee6605/digitalassets/standaloneforms/34a4ab24-c945-f011-877a-6045bde15d9b"
              rel="nofollow"
            >
              Register
            </Link>
          </button>
        </div>
      </div> */}
    </section >
  );
};

export default SectionHeader;